

















































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { required } from 'vuelidate/lib/validators';
import DropdownLight from '@/shared/dropdown-light/dropdown-light.vue';

@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
  },
  validations: {
    productPlatform: { required },
  },
})
export default class NsvSerialProductPlatform extends SwExtendedVue {
  @Prop()
  showNSVRegistration: boolean;
  @Prop()
  serialNumber: string;
  submitted: boolean = false;
  productPlatform: string = '';
  errorMessage: string = '';
  nsvPlatFormOptions: [] = [];
  closeDialog() {
    this.$emit('closeDialog');
  }
  validateForm() {
    this.submitted = true;
    this.errorMessage = '';
    this.$v.$touch();
    if (this.$v.$invalid) {
    } else {
      const request = {
        serialNumber : this.serialNumber,
        platformID : this.productPlatform,
      };
      this.$store
        .dispatch('MswProductsStoreModule/submitProductPlatform', request)
        .then((res: any) => {
          if (res.operationStatus === 'OK') {
            this.$store.commit('stopLoading');
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
            this.$emit('closeDialog');
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
            this.$store.commit('stopLoading');
          }
        });
    }
  }
  mounted() {
    this.getProductPlatform();
  }
  getProductPlatform() {
    this.$store
    .dispatch('MswProductsStoreModule/getNsvPlatforms')
    .then((res: any) => {
      this.$store.commit('stopLoading');
      this.nsvPlatFormOptions = res.content.NSVPlatform.reduce(
        (a: any, b: any) => a.concat({ id: b.platformId, value: b.platformId, label: b.platformName }),
        [],
      );
    });
  }
  setNsvPlatform(platform: any) {
    this.productPlatform = platform;
    this.submitted = false;
  }
}
